import { DropdownMenuItem, LinkMenuItem } from 'router/links';

export const isLinkMenuItem = (
  menuItem: LinkMenuItem | DropdownMenuItem
): menuItem is LinkMenuItem => (menuItem as LinkMenuItem).link !== undefined;
